export const ROUTES = {
    HOME: '/',
    IMPRESSUM: '/impressum',
    CHALLENGER: '/challenger',
    ADDRESS: '/address',
    GALLERY: '/gallery',
    GALLERY_ALBUM: '/gallery/:albumId',
    AKTUELLES: '/aktuelles',
    ADMIN: '/admin',
    ADMIN_LOGIN: '/admin/login',
    ADMIN_AKTUELLES: '/admin/aktuelles',
    ADMIN_GALLERY: '/admin/gallery',
    ADMIN_FLYER: '/admin/flyer',
    DATENSCHUTZ_APP: '/datenschutz-app',
    VERANSTALTUNGEN: '/veranstaltungen',
    STORNO: '/storno/:token',
    ADMIN_BUCHUNGEN: '/admin/buchungen'
};

export const SECTION_IDS = {
    PAGE_TOP: 'page-top',
    KICK_CALENDAR: 'KickCalendar',
    AKTUELLES: 'aktuelles',
    ABOUT: 'about',
    GALLERY: 'gallery',
    CONTACT: 'contact',
    FOOTER: 'footer'
};

export const NAVIGATION_SECTIONS = [
    { id: SECTION_IDS.AKTUELLES, label: 'Aktuelles' },
    { id: SECTION_IDS.KICK_CALENDAR, label: 'Kalender' },
    { id: SECTION_IDS.ABOUT, label: 'Über uns' },
    { id: SECTION_IDS.GALLERY, label: 'Galerie' },
    { id: SECTION_IDS.CONTACT, label: 'Kontakt' }
];

export const buildGalleryAlbumRoute = (albumId) => `${ROUTES.GALLERY}/${albumId}`;
